module.exports = __webpack_public_path__ + "static/media/resultados_sobre_pobreza_7.be3c6556.png";